import { NotificationManager } from "react-notifications";

const activeToastKeys = new Set();

const clearToastLock = (uniqueKey, onExpire, onToastStateChange) => {
  if (uniqueKey) {
    activeToastKeys.delete(uniqueKey);
  }

  if (typeof onToastStateChange === "function") {
    onToastStateChange(false);
  }

  if (typeof onExpire === "function") {
    onExpire();
  }
};

//Toast
export const Toast = ({
  type = "success",
  message,
  time = 2000,
  uniqueKey,
  onExpire,
  onToastStateChange,
}) => {
  const key = uniqueKey || (Array.isArray(message) ? message.map((item) => item.message).join("|") : message);

  if (key && activeToastKeys.has(key)) {
    return false;
  }

  if (typeof onToastStateChange === "function") {
    onToastStateChange(true);
  }

  if (Array.isArray(message)) {
    let item;

    for (item of message) {
      NotificationManager[type](item.message, "", time);
    }
  } else {
    NotificationManager[type](message, "", time);
  }

  if (key) {
    activeToastKeys.add(key);
    setTimeout(() => {
      clearToastLock(key, onExpire, onToastStateChange);
    }, time);
  }

  return true;
};
